import { useTranslation } from '../../../../utils/useTranslation';
import { Tooltip } from '../../../feedback/Tooltip';
import { Box } from '../../../layout/Box';
import { DataTestId } from '../../../layout/DataTestIdWrapper';
import { Typography } from '../../../typography/Typography';
import { CHECKOUT_MORE_LINK } from '../constants';
import { IconWrapper } from '../styles';
import { CheckoutBadgeProps } from './typings';

export const CheckoutBadge = ({ Icon, right }: CheckoutBadgeProps) => {
    const t = useTranslation();

    return (
        <Tooltip
            variant="onboarding"
            options={{ placement: 'bottom' }}
            trigger={
                <IconWrapper
                    top={1}
                    right={right}
                    zIndex={1}
                    p={0.5}
                    background={'var(--search-red)'}
                    dataTestId={DataTestId.CHECKOUT_BADGE}
                >
                    <Icon size={16} color="white" />
                </IconWrapper>
            }
        >
            <Box py={0.5}>
                <Typography variant="body" weight="bold" color="invert" loose>
                    {t('Можно купить в 1 клик')}
                </Typography>
                <br />
                <Typography variant="body" color="invert" loose>
                    {t(
                        'Перед оформлением заказа попросим подтвердить адрес доставки и способ оплаты',
                    )}
                </Typography>
                <br />
                <Typography
                    as="a"
                    target="_blank"
                    width="fit-content"
                    href={CHECKOUT_MORE_LINK}
                    rel="noopener noreferrer"
                    variant="body"
                    color="var(--color-secondary-invert)"
                    loose
                >
                    {t('Подробнее')}
                </Typography>
            </Box>
        </Tooltip>
    );
};
